export const resourceItems = [
  {
    icon: 'file',
    type: 'Articles',
    title: 'Five Cost Controls That Protect Margin',
    description:
      'Practical controls you can put in place this week to stop margin leaks at the source.',
  },
  {
    icon: 'book',
    type: 'Whitepapers',
    title: 'The Operational Intelligence Playbook',
    description:
      'How data-driven operators build reporting systems that scale across locations.',
  },
  {
    icon: 'chart',
    type: 'Case Studies',
    title: 'How a restaurant reclaimed 4.2% of net margin',
    description:
      'A 30-day implementation that rebuilt purchasing, costing, and labor visibility.',
  },
  {
    icon: 'clipboard',
    type: 'Templates',
    title: 'SOP & Inventory Count Templates',
    description:
      'Ready-to-use documents for standardizing counts, prep, and closing procedures.',
  },
  {
    icon: 'calculator',
    type: 'Business Calculators',
    title: 'Food Cost & Labor Calculators',
    description:
      'Model recipe cost, prime cost, and break-even scenarios before you commit.',
  },
  {
    icon: 'video',
    type: 'Videos',
    title: 'Platform Walkthrough Series',
    description:
      'Short sessions covering dashboards, reporting, and AI insights in practice.',
  },
  {
    icon: 'help',
    type: 'FAQs',
    title: 'Getting Started with ROI Complete',
    description:
      'Answers on onboarding, integrations, timelines, and what to expect in month one.',
  },
]
